var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import Modal from 'react-modal';
import styled from '@emotion/styled/macro';
import CircularSlider from '@fseehawer/react-circular-slider';
import Picker from 'react-mobile-picker';
import { ModalContainer, ModalContent, ModalHeader, ModalStyle } from '../../common/modals';
import { TemperatureIcon } from '../../common/TemperatureIcon';
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('html');
var CircularSliderContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin-bottom: 40px;\n"], ["\n  position: relative;\n  margin-bottom: 40px;\n"])));
var LabelContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 85px;\n  left: 70px;\n"], ["\n  position: absolute;\n  top: 85px;\n  left: 70px;\n"])));
var LabelTitle = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #F29F41;\n  font-size: 14px;\n  font-weight: 600;\n"], ["\n  color: #F29F41;\n  font-size: 14px;\n  font-weight: 600;\n"])));
var LabelTemperature = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 48px;\n  font-weight: bold;\n"], ["\n  font-size: 48px;\n  font-weight: bold;\n"])));
export var ThermostatCardModal = function (_a) {
    var close = _a.close, currentMode = _a.currentMode, currentTemperature = _a.currentTemperature, modes = _a.modes, name = _a.name, targetTemperature = _a.targetTemperature, onTemperatureChange = _a.onTemperatureChange, onModeChange = _a.onModeChange, show = _a.show, state = _a.state, tempMax = _a.tempMax, tempMin = _a.tempMin;
    var on = currentMode !== 'Off';
    var stateLabel = on ? "Heat to ".concat(targetTemperature.toFixed(1), "\u00B0") : 'Off';
    function handleSliderChange(value) {
        if (onTemperatureChange) {
            onTemperatureChange(value);
        }
    }
    function handleModeChange(key, value) {
        if (onModeChange) {
            onModeChange(value);
        }
    }
    return (React.createElement(Modal, { isOpen: show, onRequestClose: close, contentLabel: "Example Modal", style: ModalStyle },
        React.createElement(ModalContainer, null,
            React.createElement(ModalHeader, { title: name, subtitle: stateLabel, close: close, icon: React.createElement(TemperatureIcon, { temperature: currentTemperature }) }),
            React.createElement(ModalContent, null,
                React.createElement(CircularSliderContainer, null,
                    React.createElement(CircularSlider, { label: "Temperature", hideLabelValue: true, appendToValue: "\u00B0", min: tempMin, max: tempMax, width: 250, knobPosition: "bottom", knobColor: "#005a58", progressColorFrom: "#75D5E2", progressColorTo: "#ED6C35", progressSize: 24, trackColor: "#eeeeee", trackSize: 24, dataIndex: targetTemperature - tempMin, onChange: handleSliderChange, hideKnob: !on }),
                    React.createElement(LabelContainer, null,
                        React.createElement(LabelTitle, null, on ? "HEATING TO" : "NOW"),
                        React.createElement(LabelTemperature, null,
                            on ? targetTemperature.toFixed(1) : currentTemperature.toFixed(1),
                            "\u00B0"))),
                React.createElement(Picker, { height: 100, optionGroups: {
                        mode: modes,
                    }, valueGroups: {
                        mode: currentMode,
                    }, onChange: handleModeChange })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ThermostatCardModal.js.map